import * as stringSimilarity from 'string-similarity'

// ฟังก์ชันสำหรับแยกข้อมูลจากข้อความ
export const parseThaiAddressOld = (text: string) => {
  // แยกข้อความเป็นบรรทัด
  const lines = text
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line)

  // Regex patterns
  const patterns = {
    // ชื่อ: รองรับทั้งภาษาไทย, อังกฤษ และเครื่องหมายต่างๆที่อาจพบในชื่อสถานที่
    // [ก-๙] - ตัวอักษรไทย
    // [a-zA-Z] - ตัวอักษรอังกฤษ
    // [0-9] - ตัวเลข (สำหรับชื่อสถานที่ที่มีตัวเลข)
    // [\s.,()\-'] - เว้นวรรค, จุด, คอมม่า, วงเล็บ, ขีดกลาง, อัญประกาศเดี่ยว
    name: /^([ก-๙a-zA-Z0-9\s.,()\-']+?)(?=\s*[0-9]{9,10}|$)/,

    // เบอร์โทร: ตัวเลข 9-10 หลัก
    phone: /[0-9]{9,10}/,

    // ตำบล/แขวง
    subDistrict: /(?:ต\.|ตำบล|แขวง)\s*([ก-๙]+)/,

    // อำเภอ/เขต
    district: /(?:อ\.|อำเภอ|เขต|ข\.)\s*([ก-๙]+)/,

    // จังหวัด
    province: /(?:จ\.|จังหวัด)\s*([ก-๙]+)/,

    // รหัสไปรษณีย์: ตัวเลข 5 หลัก
    zipcode: /\b([0-9]{5})\b/,
  }

  // Object เก็บผลลัพธ์
  const result = {
    name: '',
    phone: '',
    address: '',
    subDistrict: '',
    district: '',
    province: '',
    zipcode: '',
  }

  // แยกชื่อและเบอร์โทรจากบรรทัดแรก
  if (lines[0]) {
    const nameMatch = lines[0].match(patterns.name)
    if (nameMatch) {
      result.name = nameMatch[1].trim()
      // ถ้าชื่อลงท้ายด้วยเครื่องหมายวรรคตอน ให้ตัดออก
      result.name = result.name.replace(/[,.\s]+$/, '')
    }

    const phoneMatch = lines[0].match(patterns.phone)
    if (phoneMatch) result.phone = phoneMatch[0]
  }

  // ถ้าเบอร์โทรอยู่บรรทัดที่สอง
  if (lines[1] && !result.phone) {
    const phoneMatch = lines[1].match(patterns.phone)
    if (phoneMatch) result.phone = phoneMatch[0]
  }

  // แยกที่อยู่จากบรรทัดสุดท้าย
  const addressLine = lines[lines.length - 1]
  if (addressLine) {
    // แยกรหัสไปรษณีย์ก่อน เพื่อไม่ให้ปนกับที่อยู่
    const zipcodeMatch = addressLine.match(patterns.zipcode)
    if (zipcodeMatch) {
      result.zipcode = zipcodeMatch[1]
    }

    // แยกส่วนประกอบของที่อยู่
    let addressText = addressLine

    // เก็บตำแหน่งเริ่มต้นของ ตำบล/แขวง, อำเภอ/เขต, จังหวัด
    let subDistrictIndex = -1
    let districtIndex = -1
    let provinceIndex = -1

    // หาตำแหน่งของแต่ละส่วน
    const subDistrictMatch = addressText.match(patterns.subDistrict)
    if (subDistrictMatch) {
      subDistrictIndex = addressText.indexOf(subDistrictMatch[0])
      result.subDistrict = subDistrictMatch[1].trim()
    }

    const districtMatch = addressText.match(patterns.district)
    if (districtMatch) {
      districtIndex = addressText.indexOf(districtMatch[0])
      result.district = districtMatch[1].trim()
    }

    const provinceMatch = addressText.match(patterns.province)
    if (provinceMatch) {
      provinceIndex = addressText.indexOf(provinceMatch[0])
      result.province = provinceMatch[1].trim()
    }

    // const province = TH_PROVINCES.find((prov) =>
    //   addressText.includes(`${prov}`),
    // )

    // if (province) {
    //   result.province = province
    // }
    if (['กทม', 'กทม.'].includes(result.province)) {
      result.province = 'กรุงเทพมหานคร'
    } else {
      const province = stringSimilarity.findBestMatch(
        result.province,
        TH_PROVINCES,
      )
      if (province.bestMatch.rating >= 0.4) {
        result.province = province.bestMatch.target
      }
    }

    if (result.district === 'เมือง') {
      result.district = `เมือง${result.province}`
    }

    // result.province = province || result.province
    // if (addressText.includes('กรุงเทพมหานคร')) {
    //   provinceIndex = addressText.indexOf('กรุงเทพมหานคร')
    //   result.province = 'กรุงเทพมหานคร'
    // } else {
    //   const provinceMatch = addressText.match(patterns.province)
    //   if (provinceMatch) {
    //     provinceIndex = addressText.indexOf(provinceMatch[0])
    //     if (provinceMatch[1]) {
    //       result.province = provinceMatch[1].trim()
    //     }
    //   }
    // }

    // หาตำแหน่งแรกที่เจอ (ไม่นับ -1)
    const firstIndex = [subDistrictIndex, districtIndex, provinceIndex]
      .filter((index) => index !== -1)
      .sort((a, b) => a - b)[0]

    // ถ้าเจอส่วนใดส่วนหนึ่ง ให้ตัดเอาข้อความก่อนหน้านั้นเป็นที่อยู่
    if (firstIndex !== undefined) {
      result.address = addressText.substring(0, firstIndex).trim()
    }

    // ถ้าไม่เจอส่วนใดเลย แต่มีข้อความที่ดูเหมือนที่อยู่ ให้ถือว่าเป็นที่อยู่ทั้งหมด
    if (!result.address && /^[0-9ก-๙a-zA-Z\s.,()\-'/]+/.test(addressText)) {
      result.address = addressText.replace(patterns.zipcode, '').trim()
    }
  }

  return result
}

export const parseThaiAddress = (text: string) => {
  // แยกข้อความเป็นบรรทัด
  const lines = text
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line)

  // Regex patterns
  const patterns = {
    name: /^([ก-๙a-zA-Z0-9\s.,()\-']+?)(?=\s*[0-9]{9,10}|$)/,
    phone: /[0-9]{9,10}/,
    subDistrict: /(?:ต\.|ตำบล|แขวง)\s*([ก-๙]+)/,
    district: /(?:อ\.|อำเภอ|เขต|ข\.)\s*([ก-๙]+)/,
    province: /(?:จ\.|จังหวัด)\s*([ก-๙]+)/,
    zipcode: /\b([0-9]{5})\b/,
    // Pattern สำหรับจุดเริ่มต้นของที่อยู่
    addressStart: /(\d+\/\d+|\d+\s+หมู่|หมู่\s*\d+)/,
  }

  // Object เก็บผลลัพธ์
  const result = {
    name: '',
    phone: '',
    address: '',
    subDistrict: '',
    district: '',
    province: '',
    zipcode: '',
  }

  // ฟังก์ชันแยกชื่อและที่อยู่จากบรรทัดเดียวกัน
  const splitNameAndAddress = (line: string) => {
    let name = ''
    let addressPart = ''

    // หาตำแหน่งเริ่มต้นของที่อยู่
    const addressStartMatch = line.match(patterns.addressStart)

    if (addressStartMatch && addressStartMatch.index !== undefined) {
      // แยกชื่อและที่อยู่
      name = line.substring(0, addressStartMatch.index).trim()
      addressPart = line.substring(addressStartMatch.index).trim()
    } else {
      // ถ้าไม่เจอจุดเริ่มต้นของที่อยู่ ลองหาว่ามีส่วนประกอบของที่อยู่ไหม
      const subDistrictMatch = line.match(patterns.subDistrict)
      const districtMatch = line.match(patterns.district)
      const provinceMatch = line.match(patterns.province)

      const matches = [subDistrictMatch, districtMatch, provinceMatch]
        .filter((m) => m !== null && m.index !== undefined)
        .sort((a, b) => a!.index! - b!.index!)

      if (matches.length > 0 && matches[0]!.index !== undefined) {
        // ใช้ส่วนประกอบแรกที่เจอเป็นจุดตัด
        name = line.substring(0, matches[0]!.index).trim()
        addressPart = line.substring(matches[0]!.index).trim()
      } else {
        // ถ้าไม่เจอเลย ถือว่าทั้งบรรทัดเป็นชื่อ
        name = line
      }
    }

    // ลบเครื่องหมายวรรคตอนท้ายออกจากชื่อ
    name = name.replace(/[,.\s]+$/, '')

    return { name, addressPart }
  }

  // เก็บ candidates สำหรับแต่ละฟิลด์
  const candidates = {
    phones: [] as { value: string; lineIndex: number }[],
    names: [] as { value: string; lineIndex: number }[],
    addressLines: [] as {
      value: string
      lineIndex: number
      hasAddressComponents: boolean
    }[],
  }

  // สแกนทุกบรรทัดเพื่อหาข้อมูลที่เป็นไปได้
  lines.forEach((line, index) => {
    // หาเบอร์โทร
    const phoneMatch = line.match(patterns.phone)
    if (phoneMatch) {
      candidates.phones.push({ value: phoneMatch[0], lineIndex: index })
    }

    // หาส่วนประกอบของที่อยู่ (ตำบล, อำเภอ, จังหวัด, รหัสไปรษณีย์)
    const hasSubDistrict = patterns.subDistrict.test(line)
    const hasDistrict = patterns.district.test(line)
    const hasProvince = patterns.province.test(line)
    const hasZipcode = patterns.zipcode.test(line)
    const hasAddressStart = patterns.addressStart.test(line)
    const hasAddressComponents =
      hasSubDistrict ||
      hasDistrict ||
      hasProvince ||
      hasZipcode ||
      hasAddressStart

    // เก็บบรรทัดที่มีส่วนประกอบของที่อยู่
    if (hasAddressComponents) {
      // แยกชื่อและที่อยู่ออกจากกัน
      const { name, addressPart } = splitNameAndAddress(line)

      // ถ้ามีชื่อ ให้เพิ่มเข้า candidates
      if (name && name.length > 0) {
        // ตรวจสอบว่าชื่อไม่ใช่เบอร์โทรอย่างเดียว
        const namePhoneMatch = name.match(patterns.phone)
        const isOnlyPhone =
          namePhoneMatch &&
          name.replace(namePhoneMatch[0], '').trim().length === 0

        if (!isOnlyPhone) {
          let cleanName = name
          // ลบเบอร์โทรออกจากชื่อถ้ามี
          if (namePhoneMatch) {
            cleanName = name.replace(namePhoneMatch[0], '').trim()
          }
          if (cleanName.length > 0) {
            candidates.names.push({ value: cleanName, lineIndex: index })
          }
        }
      }

      // เก็บส่วนที่อยู่
      candidates.addressLines.push({
        value: addressPart || line,
        lineIndex: index,
        hasAddressComponents: true,
      })
    } else {
      // บรรทัดที่ไม่มีส่วนประกอบของที่อยู่
      const isOnlyPhone =
        phoneMatch && line.replace(phoneMatch[0], '').trim().length === 0
      if (!isOnlyPhone && line.length > 0) {
        // ลบเบอร์โทรออกเพื่อเก็บแค่ชื่อ
        let nameCandidate = line
        if (phoneMatch) {
          nameCandidate = line.replace(phoneMatch[0], '').trim()
        }

        if (nameCandidate.length > 0) {
          // ตัดเครื่องหมายวรรคตอนท้ายสุดออก
          nameCandidate = nameCandidate.replace(/[,.\s]+$/, '')
          candidates.names.push({ value: nameCandidate, lineIndex: index })
        }
      }
    }
  })

  // เลือกเบอร์โทร: ให้ความสำคัญกับบรรทัดแรกก่อน
  if (candidates.phones.length > 0) {
    result.phone = candidates.phones[0].value
  }

  // เลือกชื่อ: ให้ความสำคัญกับบรรทัดแรกที่ไม่มีส่วนประกอบของที่อยู่
  if (candidates.names.length > 0) {
    result.name = candidates.names[0].value
  }

  // ประมวลผลที่อยู่: รวมทุกบรรทัดที่มีส่วนประกอบของที่อยู่
  const allAddressText = candidates.addressLines
    .map((item) => item.value)
    .join(' ')

  // ถ้าไม่มีบรรทัดที่มีส่วนประกอบของที่อยู่ ให้ใช้บรรทัดที่เหลือทั้งหมด
  if (candidates.addressLines.length === 0) {
    // รวมบรรทัดที่ไม่ใช่ชื่อและเบอร์โทร
    const usedLineIndices = new Set([
      ...candidates.names.map((n) => n.lineIndex),
      ...candidates.phones.filter((p, i) => i === 0).map((p) => p.lineIndex), // เอาแค่เบอร์โทรที่เลือก
    ])

    const remainingLines = lines.filter(
      (_, index) => !usedLineIndices.has(index),
    )
    if (remainingLines.length > 0) {
      result.address = remainingLines.join(' ')
    }
  } else {
    // แยกส่วนประกอบจาก allAddressText
    const zipcodeMatch = allAddressText.match(patterns.zipcode)
    if (zipcodeMatch) {
      result.zipcode = zipcodeMatch[1]
    }

    const subDistrictMatch = allAddressText.match(patterns.subDistrict)
    if (subDistrictMatch) {
      result.subDistrict = subDistrictMatch[1].trim()
    }

    const districtMatch = allAddressText.match(patterns.district)
    if (districtMatch) {
      result.district = districtMatch[1].trim()
    }

    const provinceMatch = allAddressText.match(patterns.province)
    let provinceTextInAddress: string | undefined
    if (provinceMatch) {
      result.province = provinceMatch[1].trim()
      provinceTextInAddress = provinceMatch[0]
    }

    // Fallback: ถ้าไม่มี จ. หรือ จังหวัด ให้เช็คจาก list 77 จังหวัด (ตรงตัว แล้วถ้าไม่เจอลอง fuzzy รองรับพิมพ์ผิด)
    if (!result.province) {
      const sortedProvinces = [...TH_PROVINCES].sort(
        (a, b) => b.length - a.length,
      )
      let found = sortedProvinces.find((prov) =>
        allAddressText.includes(prov),
      )
      if (found) provinceTextInAddress = found

      if (!found && zipcodeMatch && zipcodeMatch.index !== undefined) {
        // ดึงช่วงข้อความก่อนรหัสไปรษณีย์ (มักเป็นชื่อจังหวัด อาจพิมพ์ผิด)
        const beforeZip = allAddressText.substring(0, zipcodeMatch.index).trim()
        const tail = beforeZip.split(/\s+/).pop() ?? ''
        if (tail && /[ก-๙]/.test(tail)) {
          // รองรับ "กทม" / "กทม." โดยตรง (fuzzy ให้ rating 0 เพราะสั้นเกินไป)
          if (['กทม', 'กทม.'].includes(tail)) {
            found = 'กรุงเทพมหานคร'
            provinceTextInAddress = tail
          } else {
            const fuzzy = stringSimilarity.findBestMatch(tail, TH_PROVINCES)
            if (fuzzy.bestMatch.rating >= 0.4) {
              found = fuzzy.bestMatch.target
              provinceTextInAddress = tail
            }
          }
        }
        if (!found && beforeZip.length >= 2) {
          const lastChunk = beforeZip.slice(-30).trim()
          const fuzzy = stringSimilarity.findBestMatch(lastChunk, TH_PROVINCES)
          if (fuzzy.bestMatch.rating >= 0.4) {
            found = fuzzy.bestMatch.target
            provinceTextInAddress = lastChunk
          }
        }
      }
      if (found) result.province = found
    }

    // จัดการกรณีพิเศษสำหรับจังหวัด
    if (['กทม', 'กทม.'].includes(result.province)) {
      result.province = 'กรุงเทพมหานคร'
    } else if (result.province) {
      const province = stringSimilarity.findBestMatch(
        result.province,
        TH_PROVINCES,
      )
      if (province.bestMatch.rating >= 0.4) {
        result.province = province.bestMatch.target
      }
    }

    // จัดการกรณีอำเภอเมือง
    if (result.district === 'เมือง' && result.province) {
      result.district = `เมือง${result.province}`
    }

    // หา address โดยตัดส่วนที่เป็น subDistrict, district, province, zipcode ออก
    let addressText = allAddressText

    // หาตำแหน่งของแต่ละส่วน
    let subDistrictIndex = -1
    let districtIndex = -1
    let provinceIndex = -1

    if (subDistrictMatch) {
      subDistrictIndex = addressText.indexOf(subDistrictMatch[0])
    }
    if (districtMatch) {
      districtIndex = addressText.indexOf(districtMatch[0])
    }
    if (provinceTextInAddress) {
      provinceIndex = addressText.indexOf(provinceTextInAddress)
    }

    // หาตำแหน่งแรกที่เจอ
    const firstIndex = [subDistrictIndex, districtIndex, provinceIndex]
      .filter((index) => index !== -1)
      .sort((a, b) => a - b)[0]

    // ตัดเอาข้อความก่อนหน้าเป็นที่อยู่
    if (firstIndex !== undefined) {
      result.address = addressText.substring(0, firstIndex).trim()
    }

    // ถ้าไม่เจอส่วนใดเลย
    if (!result.address && /^[0-9ก-๙a-zA-Z\s.,()\-'/]+/.test(addressText)) {
      result.address = addressText.replace(patterns.zipcode, '').trim()
    }
  }

  return result
}

export const TH_PROVINCES = [
  'กรุงเทพมหานคร',
  'กระบี่',
  'กาญจนบุรี',
  'กาฬสินธุ์',
  'กำแพงเพชร',
  'ขอนแก่น',
  'จันทบุรี',
  'ฉะเชิงเทรา',
  'ชลบุรี',
  'ชัยนาท',
  'ชัยภูมิ',
  'ชุมพร',
  'เชียงราย',
  'เชียงใหม่',
  'ตรัง',
  'ตราด',
  'ตาก',
  'นครนายก',
  'นครปฐม',
  'นครพนม',
  'นครราชสีมา',
  'นครศรีธรรมราช',
  'นครสวรรค์',
  'นนทบุรี',
  'นราธิวาส',
  'น่าน',
  'บึงกาฬ',
  'บุรีรัมย์',
  'ปทุมธานี',
  'ประจวบคีรีขันธ์',
  'ปราจีนบุรี',
  'ปัตตานี',
  'พระนครศรีอยุธยา',
  'พะเยา',
  'พังงา',
  'พัทลุง',
  'พิจิตร',
  'พิษณุโลก',
  'เพชรบุรี',
  'เพชรบูรณ์',
  'แพร่',
  'ภูเก็ต',
  'มหาสารคาม',
  'มุกดาหาร',
  'แม่ฮ่องสอน',
  'ยโสธร',
  'ยะลา',
  'ร้อยเอ็ด',
  'ระนอง',
  'ระยอง',
  'ราชบุรี',
  'ลพบุรี',
  'ลำปาง',
  'ลำพูน',
  'เลย',
  'ศรีสะเกษ',
  'สกลนคร',
  'สงขลา',
  'สตูล',
  'สมุทรปราการ',
  'สมุทรสงคราม',
  'สมุทรสาคร',
  'สระแก้ว',
  'สระบุรี',
  'สิงห์บุรี',
  'สุโขทัย',
  'สุพรรณบุรี',
  'สุราษฎร์ธานี',
  'สุรินทร์',
  'หนองคาย',
  'หนองบัวลำภู',
  'อ่างทอง',
  'อำนาจเจริญ',
  'อุดรธานี',
  'อุตรดิตถ์',
  'อุทัยธานี',
  'อุบลราชธานี',
  'อ่างทอง',
]
